import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import CommonPageComponent from '../../common/ui/CommonPageComponent';
import { FigmaToHtml } from '../ai-prompt-builder/figmaConfig/FigmaToHtml';
import * as plugin from '../plugin/redux/actions';
import { getUniqueRolesByName } from './utils';
export class FigmaToLayouts extends Component {
  static propTypes = {
    aiPromptBuilder: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
  };
  state = {
    systemRoles: [],
    userPrompt: '',
    roles: [],
  };

  async componentDidMount() {
    const { match, plugin,location} = this.props;
    const { projectId, version } = match.params;
    const { state = {} } = location;
    const { userPrompt, roles } = state;
    this.setState({ userPrompt, roles });
    const systemRoles = await plugin.loadRoles({ projectId, version });
    const uniqueSystemRoles =  getUniqueRolesByName(systemRoles.data);
    this.setState({ systemRoles: uniqueSystemRoles });
  }

  render() {
    const { match, actions, history } = this.props;
    const { projectId, version } = match.params;
    if (!projectId || !version) {
      return '';
    }

    return (
      <CommonPageComponent>
        <FigmaToHtml
          figmaTokenSubmit={actions.figmaTokenSubmit}
          fetchTokenDetails={actions.fetchTokenDetails}
          fetchFigmaImage={actions.fetchFigmaImage}
          systemRoles={this.state.systemRoles}
          projectId={projectId}
          version={version}
          history={history}
          userPrompt={this.state.userPrompt}
          roles={this.state.roles}
          generateFigmaLayouts={actions.generateFigmaLayouts}
        ></FigmaToHtml>
      </CommonPageComponent>
    );
  }
}

function mapStateToProps(state) {
  return {
    aiPromptBuilder: state.aiPromptBuilder,
    plugin: state.plugin,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
    plugin: bindActionCreators({ ...plugin }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(FigmaToLayouts);
